import React, { Component } from 'react';
import { Box } from 'grommet/components/Box';
import { Anchor } from 'grommet/components/Anchor';
import { Image } from 'grommet/components/Image';
import logo from '../Assets/logoamex.svg';


class Header extends Component {


  render() {


    return (

      <Box id='header' direction='row' className='box-shadow' style={{ padding: '0' }}>
        <Box style={{ position: 'static', padding: '0 20px', maxWidth: '1240px', margin: '0 auto', width: '1240px', display: 'inline' }} className='pagination'>
          <Anchor href='/'>
            <Image id='logoheader' style={{ margin: '10px 0', verticalAlign: 'middle', float: 'left' }} src={logo} alt="logo" />
          </Anchor>
          <Anchor id='linkheader' style={{ verticalAlign: 'middle', float: 'right' }} href='https://www.americanexpress.com/it/merchant/?inav=it_menu_business_merch_home' target='blank'>Esercizi Commerciali</Anchor>
        </Box>
      </Box>
    );
  }
}

export default Header;
